import React, { useState, useEffect, useContext } from 'react';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import { client } from './client';
import { AuthContext } from '../../auth';
import swal from 'sweetalert';
import { Redirect } from 'react-router-dom';

const style1 = {
    background: "#6CB5FD",
    color: "black",
    width: "fit-content",
    borderRadius: "20px",
    padding: "10px"
}

const style2={
    background: "whitesmoke",
color: "black",
width: "fit-content",
borderRadius: "20px",
padding: "10px",
marginLeft: "auto"
}
let from = '';
    

const ChatDashboard = (props) => {
   

    const [topic, setTopic] = useState(['abc']);
    // const [chat, setChat] = useState([{ from: "u", message: "hello" }]);
    const [text, setText] = useState('');
    const [msg, setMsg] = useState([]);
    const [logedinuser, setLogedinuser] = useContext(AuthContext);

    const id = props.match.params.id;

    
   

    



    useEffect(() => {

        client.open();
        //creating subscription 
        let query = new Parse.Query('chat');
        let subscription =  client.subscribe(query);
        subscription.on('open', ()=>{
            console.log('subscription opened');
        });
        //subscription created

        //fires on message i.e on update
        subscription.on('update', (object)=>{
            console.log('object updated',object);
            setText('');
            if(object.get('chatid')===id){
                setMsg(object.get('msg'));
            }


        });
        //end
        
        if(id.slice(0,10)===logedinuser){
            from='c';
        }
        else{
            from='u';
        }


        //chatobject
        const Chat = Parse.Object.extend('chat');
        const nquery = new Parse.Query(Chat);


        //
        nquery.equalTo('chatid',id).find().then((cc)=>{
            console.log(cc);
            if(cc.length!==1){
                const chat = new Chat();
                chat.set('chatid',id);
                chat.set('msg',[]);
                chat.save()
                    .then((c)=>{
                        console.log(c,"created new chat");

                    },(error)=>{
                        console.error(error,"cannot create new");
                    })
            }
            else{
                setMsg(cc[0].get("msg"));
            }


        },(error)=>{
            console.log(error);
        })

        return()=>{
            Parse.LiveQuery.close();
        };


        
    }, [])








    const send = () => {


        let newMsg = [...msg];
        let newText = {from:from,message:text};

        newMsg.push(newText);
        console.log(newMsg);



        const Chat = Parse.Object.extend('chat');
        const query = new Parse.Query(Chat);
        query.equalTo('chatid', id).find().then((c) => {
            console.log(c);
            c[0].set('msg', newMsg);
            c[0].save()
                .then((data) => {
                    console.log('saved new message!@1241241451514');


                }, (error) => {
                    console.log(error, 'cannot save new mesage');
                })
        }, (error) => {
            console.log(error, 'didnt find');

        })


    }

    return (
        <div>
            {(logedinuser == null) &&(<div>
                {swal("Oops!", "Please login to continue")}
            </div>) &&(
                 <Redirect to={{
                     pathname:'/'  
                    }}/>
            )}
            {/* <Navbar head="Chat" /> */}
            <div className="container" style={{ marginTop: "70px" }}>
                <div className="row justify-content-center">
                    <div className="col-md-8"  >
                        <div className="card" style={{ height: "88vh" }}>
                            <div className="card-body" style={{ height: "100%" }}>
                                <div className="text-center">
                                    <h2>Chat App</h2>
                                    <hr />

                                </div>

                                <div className="chat" style={{ height: "80%" }} >
                                    <div className="p-2" style={{ height: "100%", overflow: "scroll" }}>
                                        {
                                            msg.map((m, i) => {
                                                let d=null;
                                                if(m.from==='c'){
                                                    d=style1;
                                                }
                                                else{
                                                    d=style2;
                                                }
                                                return (
                                                    <div key={i}>
                                                        <p style={d}>{m.message}</p>
                                                        
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>

                                <div className="row">
                                    <div class="input-group mt-3">
                                        <input type="text" className="form-control" placeholder="Type Here" aria-label="Type Here" aria-describedby="basic-addon2"
                                        required
                                            value={text}
                                            onChange={e => setText(e.target.value)}
                                            style={{borderRadius:"0"}}
                                        />
                                        <div className="input-group-append">
                                            <button className="btn-outline-secondary px-3" type="button"
                                            onClick={send}
                                            style={{border:"none",fontSize:"17px",borderRadius:"20px"}}>Send</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ChatDashboard;